import { jsonp } from '@ifeng-fe/ui_base';

/**
 * 信息流互动累加（like / ding / cai / flower / candle / cheer）
 * @see https://survey.news.ifeng.com/api/accumulator
 * @param {string} type 互动类型
 * @param {string} articleId 文章 / 节点 id
 */
export const postInteractionAccumulate = ({ type, articleId }) => {
    const callbackName = 'timelineAccumulatorCallback';

    return jsonp('https://survey.news.ifeng.com/api/accumulator', {
        data: {
            // 实际联调：key[0] 会被服务端判为非法数组，需传字符串 key
            key: `timeline_${type}_${articleId}`,
            format: 'js',
            serviceid: 1,
        },
        jsonpCallback: callbackName,
        cache: false,
    });
};
